<!-- Schema.org -->
<div [innerHtml]="getJson() | safe:'html'"></div>